import { Typography } from "@mui/material"

const CustomHeader = props =>
    <Typography
        variant="h2"
        gutterBottom
        fontFamily={"League Gothic, sans-serif"}
        sx={{
            color: props.color,
            fontSize: { xs: 36, md: 48, lg: 56 },
            mb: 5
        }}
    >
        {props.title}
    </Typography>

export default CustomHeader